import Home from "./home.view";

const HomeContainer = () => {
  // const navigate = useNavigate();

  return <Home />;
};

export default HomeContainer;
